import styled from 'styled-components';

export const SummaryTableSC = styled.div`
  .loan-summary-wrap {
    margin-top: 24px;
    padding: 24px;
    border: 1px solid rgba(47, 46, 65, 0.2);
    border-radius: 12px;

    small {
      width: 50%;
    }

    &--bottom {
      padding-top: 0px;
      display: flex;
      flex-direction: column;
      &__row {
        padding-bottom: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        &:last-child {
          padding-bottom: 0px;
        }
      }
    }
  }
`;
